import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BarChart3Icon, ChevronRightIcon } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { eventTitle, eventTypeClass, eventTypeShort, formatDate } from '../../utils/labels';
export function AdminAttendanceIndex() {
  const {
    events,
    attendance,
    today,
    expectedFor
  } = useApp();
  const [prikaz, setPrikaz] = useState<'zaVpis' | 'vsi'>('zaVpis');
  const stetiDogodki = events.filter(e => e.steje).sort((a, b) => b.datum.localeCompare(a.datum));
  const zaVpis = stetiDogodki.filter(e => e.datum <= today && !attendance[e.id]);
  const relevantni = prikaz === 'zaVpis' && zaVpis.length > 0 ? zaVpis : stetiDogodki;
  return <div className="space-y-5" data-id="element-590" data-mp="5yjdekhvteav">
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-591" data-mp="azyuk1gxv0nz">
        <div data-id="element-592" data-mp="1l4z7pmxr13sk">
          <h1 className="text-2xl font-semibold text-ink" data-id="element-593" data-mp="1l4phpzcpewmv">Prisotnost</h1>
          <p className="mt-0.5 text-sm text-ink-muted" data-id="element-594" data-mp="1l2mgska0jj3d">Vpis prisotnosti po dogodkih.</p>
        </div>
        <Link to="/admin/porocilo" data-id="element-595" data-mp="1g41qbckkcds4">
          <Button variant="secondary" data-id="element-596" data-mp="1txiyy2bpo63d">
            <BarChart3Icon className="h-4 w-4" data-id="element-597" data-mp="1twhlxsb4x9j0" />
            Poročilo in analitika
          </Button>
        </Link>
      </div>

      <div className="flex flex-wrap gap-2" data-id="element-598" data-mp="1263eoexmmvgb">
        {([['zaVpis', `Čaka vpis${zaVpis.length ? ` (${zaVpis.length})` : ''}`], ['vsi', `Vsi dogodki (${stetiDogodki.length})`]] as const).map(([k, label]) => <button key={k} onClick={() => setPrikaz(k)} aria-pressed={prikaz === k} className={`rounded-lg border px-3 py-1.5 text-[13px] font-medium transition-colors duration-150 ease-out ${prikaz === k ? 'border-green-500 bg-green-500 text-white' : 'border-line bg-white text-ink-muted hover:bg-canvas hover:text-ink'}`} data-id="element-599" data-mp="1b8clatpry4of">
            {label}
          </button>)}
      </div>

      {relevantni.length === 0 ? <Card className="p-10 text-center" data-id="element-600" data-mp="1oadkux4yh5f7">
          <p className="text-sm font-medium text-ink" data-id="element-601" data-mp="1obf8e135rkdt">Prisotnost je vpisana za vse dogodke.</p>
          <p className="mt-1 text-[13px] text-ink-muted" data-id="element-602" data-mp="1t7xb6vexh8ni">Lepo opravljeno.</p>
        </Card> : <Card className="divide-y divide-line" data-id="element-603" data-mp="wk92t54o4uh5">
        {relevantni.map(e => {
        const marks = attendance[e.id];
        const prisotnih = marks ? Object.values(marks).filter(m => m === 'prisoten').length : null;
        return <Link key={e.id} to={`/admin/prisotnost/${e.id}`} className="flex flex-wrap items-center gap-3 px-5 py-4 transition-colors duration-150 ease-out hover:bg-canvas" data-id="element-604" data-mp="1aacjlgks3vz7">
              <span className="w-24 shrink-0 text-[13px] font-medium text-ink" data-id="element-605" data-mp="ht9xc2z4qm1s">{formatDate(e.datum)}</span>
              <span className="min-w-0 flex-1" data-id="element-606" data-mp="a9hhpqac5nej">
                <span className="block truncate text-sm font-medium text-ink" data-id="element-607" data-mp="a86fvw0gapq2">{eventTitle(e)}</span>
                <span className="block text-[13px] text-ink-muted" data-id="element-608" data-mp="59mrzq2ar3v2">
                  {e.zacetek} · {e.lokacija} · {expectedFor(e).length} pričakovanih
                </span>
              </span>
              <Badge className={eventTypeClass[e.type]} data-id="element-609" data-mp="3si8dm2ed47pz">{eventTypeShort[e.type]}</Badge>
              {marks ? <Badge className="bg-green-50 text-green-700 border-green-200" dot="bg-green-500" data-id="element-610" data-mp="3iqcd6kot05il">
                  {prisotnih} prisotnih
                </Badge> : <Badge className="bg-amber-50 text-amber-800 border-amber-200" data-id="element-611" data-mp="3dp6dg2wq7hzk">Ni vpisana</Badge>}
              <ChevronRightIcon className="h-4 w-4 text-ink-muted" data-id="element-612" data-mp="34ql1iqlrf17r" />
            </Link>;
      })}
      </Card>}
    </div>;
}